export default __webpack_public_path__ + "static/banner-30cc1fee8ca3a87f4ffe41d6b36b7cce.png";